"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/**
 * Crop upper section of rect
 *
 * @param  {Object}  rect
 * @return {Object} cropped rect
 */

var crop = function crop(height, rect) {
  var y = rect.y + height;
  var h = rect.height - height;
  return Object.assign({}, rect, {
    y: y,
    height: h
  });
};

var _default = crop;
exports["default"] = _default;